/**
 * Program: numberFormat
 * Author: SDL
 * Description: comma per thousand
 */
export default str => String(str).replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');



// WEBPACK FOOTER //
// ./src/filters/numberFormat.js